import { render, staticRenderFns } from "./ScreenObstetrica.vue?vue&type=template&id=ee756494&scoped=true&"
import script from "./ScreenObstetrica.vue?vue&type=script&lang=js&"
export * from "./ScreenObstetrica.vue?vue&type=script&lang=js&"
import style0 from "./ScreenObstetrica.vue?vue&type=style&index=0&id=ee756494&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee756494",
  null
  
)

export default component.exports